<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="menu-icon">
        <path d="M2.25 3.75024H15.75C15.9571 3.75024 16.1339 3.82344 16.2803 3.96984C16.4267 4.11624 16.4999 4.293 16.4999 4.50012C16.4999 4.70724 16.4267 4.884 16.2803 5.0304C16.1339 5.1768 15.9571 5.25 15.75 5.25H2.25C2.04288 5.25 1.86612 5.1768 1.71972 5.0304C1.57332 4.884 1.50012 4.70724 1.50012 4.50012C1.50012 4.293 1.57332 4.11624 1.71972 3.96984C1.86612 3.82344 2.04288 3.75024 2.25 3.75024V3.75024ZM2.25 12.7502H15.75C15.9571 12.7502 16.1339 12.8234 16.2803 12.9698C16.4267 13.1162 16.4999 13.293 16.4999 13.5001C16.4999 13.7072 16.4267 13.884 16.2803 14.0304C16.1339 14.1768 15.9571 14.25 15.75 14.25H2.25C2.04288 14.25 1.86612 14.1768 1.71972 14.0304C1.57332 13.884 1.50012 13.7072 1.50012 13.5001C1.50012 13.293 1.57332 13.1162 1.71972 12.9698C1.86612 12.8234 2.04288 12.7502 2.25 12.7502ZM2.25 8.25024H15.75C15.9571 8.25024 16.1339 8.32344 16.2803 8.46984C16.4267 8.61624 16.4999 8.793 16.4999 9.00012C16.4999 9.20724 16.4267 9.384 16.2803 9.5304C16.1339 9.6768 15.9571 9.75 15.75 9.75H2.25C2.04288 9.75 1.86612 9.6768 1.71972 9.5304C1.57332 9.384 1.50012 9.20724 1.50012 9.00012C1.50012 8.793 1.57332 8.61624 1.71972 8.46984C1.86612 8.32344 2.04288 8.25024 2.25 8.25024Z" fill="currentColor" />
    </svg>
</template>

<script>
    export default {
        name: 'MenuIcon'
    }
</script>

<style scoped>
    svg {
        height: 100%;
    }
</style>

